module.exports = __webpack_public_path__ + "img/Flizzr.f5fdb69e.gif";